import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import Breadcrumb from "../common/breadcrumb";
import StickyBox from "react-sticky-box";
import { GetPaymentData, ConfirmOrder } from '../../services/api';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import Loading from '../layouts/loading';
import Error from '../../assets/images/error.jpg';
import Check from '../../assets/images/check.png'

class PaymentResult extends Component {
    constructor(props) {
        super(props);
    };
    state = {
        layoutColumns: 3,
        quantity: 1,
        stock: 'InStock',
        paymentStatus: null,
        paymentConfirmInfo: null,
    }
    async componentDidMount() {
        this.getStatus();
    };

    async getStatus() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const rawToken = searchParams.get('token');
        let token = localStorage.getItem('callback-token-' + rawToken);
        let variant = localStorage.getItem('callback-variant-' + rawToken);
        if (token) {
            await GetPaymentData({ token }).then(async (response) => {
                this.setState(state => ({ ...state, paymentStatus: response.data.response }));
                if (response.data.response.isPaid) {
                    await ConfirmOrder({ token, variant }).then((confirmResponse) => {
                    })
                }

            });
        }
    };

    render() {
        return (
            <div>
                {/*SEO Support*/}
                <Helmet>
                    <title>ایزی کارت 724 | نتیجه پرداخت</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>
                {/*SEO Support End */}

                <Breadcrumb title={'نتیجه پرداخت'} />

                <section className="section-b-space container">
                    <div style={{ width: '50%', display: 'flex', justifyContent: 'center', padding: '1rem', textAlign: 'center' }} className="card mx-auto">
                        {this.state.paymentStatus !== null ?
                            <>{
                                (this.state.paymentStatus.isPaid === true) ?
                                    <>
                                        <img className='mx-auto' src={Check} style={{ width: '100px' }} />
                                        <h3 className='mt-4' style={{ color: 'green', textAlign: 'center' }}>پرداخت با موفقیت انجام شد</h3>
                                        <div className='text-center mt-2'>
                                            <span> شناسه سفارش :‌ </span>
                                            <span>{this.state.paymentStatus.id}</span>
                                        </div>
                                        {/* <div>
                                            <span> سریال کارت :‌ </span>
                                            <span>{this.state.paymentConfirmInfo.serial}</span>
                                        </div> */}
                                    </>
                                    :
                                    <>
                                        <div className='text-center'>
                                            <img src={Error} style={{ width: '100px' }} />
                                            <h4 className='my-3' style={{ color: 'red', textAlign: 'center' }}>پرداخت انجام نشد</h4>
                                            <span> شماره سفارش :‌ </span> <span>{this.state.paymentStatus.id}</span>
                                        </div>
                                    </>
                            }
                                <div className='mt-2' style={{ display: 'flex', justifyContent: 'center' }}>
                                    <button onClick={() => this.props.history.push('/pages/profile#orders')} className='btn btn-primary w-50 mt-2' >مشاهده سفارشات</button>
                                </div>
                            </>
                            :
                            <div>
                                <Loading></Loading>
                            </div>
                        }
                    </div>
                </section>

            </div>
        )
    }
}

export default withRouter(PaymentResult);